import { useState, useEffect, useRef, useCallback } from 'react';
import { IntersectionObserver } from 'client/utils/intersection-observer';

// Checks if the element is visible; check if the element is intersecting from bottom;
export function useOnScreenFromBottom(ref, options) {
  const [isIntersecting, setIntersecting] = useState(false);
  const [isIntersectingFromBottom, setIntersectingFromBottom] = useState(false);
  const observer = useRef();

  const disconnect = useCallback(() => {
    if (observer.current) {
      observer.current.disconnect();
      observer.current = null;
      setIntersecting(false);
    }
  }, []);

  useEffect(() => {
    if (IntersectionObserver) {
      observer.current = new IntersectionObserver(([entry]) => {
        setIntersecting(entry.isIntersecting);
        if (entry.boundingClientRect.top > 0) {
          setIntersectingFromBottom(false);
        } else {
          setIntersectingFromBottom(true);
        }
      }, options);
    }
  }, [options]);

  useEffect(() => {
    if (observer.current && ref && ref.current) {
      observer.current.observe(ref.current);
    }
  }, [ref]);

  useEffect(() => () => disconnect(), [disconnect]);

  return [isIntersecting, isIntersectingFromBottom, disconnect];
}
